class FontTagExtractor {

    public extractContent(input: string){
        // extracts the color attribute and the text content from a html font tag
        const regexPattern = '^<[a-z ]*color="(?<colour>#[a-f0-9]*)">(?<text>.*)<\/[a-z ]*>$';
        const regexComplied = new RegExp(regexPattern, 'i'); // i is for ignore case, this is to allow for any version of font and color to be used
        // break down the old font tag into useable parts, retrive groups
        const data =  (regexComplied.exec(input) as any as {groups: { colour: string, text: string}}).groups;
        if (!data.colour || !data.text) {
            throw new Error('Failed to extract font tag content');
        }

        return data;
    }
}

const fontTagExtractor = new FontTagExtractor();
export { fontTagExtractor };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/utils/font-tag-extractor.ts